var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBcu = function SvgBcu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 51.19"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h6.6v21.35a51 51 0 0 1 7-2.29 15.77 15.77 0 0 1 17.49 9.85 16.1 16.1 0 0 1-5.4 19c-5.3 3.79-11.05 4.31-16.84 1.36A15.25 15.25 0 0 1 .05 35C0 23.85 0 12.69 0 1.53Zm25.58 35.07a9.48 9.48 0 1 0-9.38 9.39 9.51 9.51 0 0 0 9.38-9.39M93.4 18.85h6.6v15.76a16 16 0 0 1-12.8 16.12 15.88 15.88 0 0 1-18-9.34 16 16 0 0 1-1.33-5.79c-.17-5.55-.06-11.1-.06-16.73h6.67v16.09a9.48 9.48 0 0 0 19 .1c.06-4.76 0-9.52 0-14.27ZM63.12 23.87l-4.65 4.59a9.52 9.52 0 1 0-13.7 13.22c3.91 3.79 8.94 3.69 13.84-.36l4.33 4.73c-2.52 3.86-9.83 6.07-15.59 4.54a16.21 16.21 0 0 1-1.87-30.68c6.01-2.47 13.52-.79 17.64 3.96"
  })))));
};
export default SvgBcu;